import { useContext, useEffect, useState } from 'react';
import { SupervisorContext } from '@/contexts/SupervisorContext';
import { AppBar, ButtonBase } from '@mui/material';
import SupervisorDialog from './SupervisorDialog';
import SupervisorHeaderText from './SupervisorHeaderText';

const SetHeaderHeight = () => {
  const { supervisorHeaderRef, setSupervisorHeaderHeight } = useContext(SupervisorContext);

  const getHeaderHeight = () => {
    if (supervisorHeaderRef?.current) {
      const style = window.getComputedStyle(supervisorHeaderRef.current);
      const marginTop = parseInt(style.marginTop || '0', 10);
      const marginBottom = parseInt(style.marginBottom || '0', 10);
      const height = supervisorHeaderRef.current.offsetHeight + marginTop + marginBottom;
      return height;
    }
    return 0;
  };

  useEffect(() => {
    setSupervisorHeaderHeight(getHeaderHeight());
  }, []);
  return null;
};

const SupervisorHeader = () => {
  const { supervisorHeaderRef, currentClient } = useContext(SupervisorContext);
  const [dialogOpen, setDialogOpen] = useState(false);

  const openDialog = () => setDialogOpen(true);

  return (
    <>
      <SupervisorDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
      {currentClient && (
        // <header> behåller sin landmärkesroll; det klickbara är en riktig knapp
        // inuti. Tidigare var hela AppBar role="button", vilket tog bort
        // header-landmärket och gav en knapp utan knappens inbyggda beteende.
        <AppBar position="sticky" color="primary" sx={{ pt: 1, pb: 0.5 }} ref={supervisorHeaderRef}>
          <SetHeaderHeight />
          <ButtonBase
            onClick={openDialog}
            aria-haspopup="dialog"
            sx={{
              display: 'block',
              width: '100%',
              color: 'inherit',
              '&:focus-visible': { outline: '2px solid currentColor', outlineOffset: '-4px' },
            }}
          >
            <SupervisorHeaderText />
          </ButtonBase>
        </AppBar>
      )}
    </>
  );
};

export default SupervisorHeader;
